import { TrackProductModuleScroll } from '../../../+product/store/actions/product.action';
import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';

/**
 * When the user scrolls on a product in modules on the product page.
 */
const events = getEvents((action: TrackProductModuleScroll) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'productModuleScrollPDP',
      productModuleTitle: action.payload.title
    }
  }
]);

export default events;
